import { render, staticRenderFns } from "./ScientificDegreesIndex.vue?vue&type=template&id=79fe4ce2"
import script from "./ScientificDegreesIndex.vue?vue&type=script&lang=js"
export * from "./ScientificDegreesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports